"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_LEADER_CARD_NAMES = exports.ALL_PRELUDE_CARD_NAMES = exports.ALL_CORPORATION_CARD_NAMES = exports.ALL_TURMOIL_ACTION_CARD_NAMES = exports.ALL_STANDARD_PROJECT_CARD_NAMES = exports.ALL_PROJECT_CARD_NAMES = exports.ALL_STANDARD_PROJECT_DECKS = exports.ALL_PRELUDE_DECKS = exports.ALL_PROJECT_DECKS = exports.MANIFEST_BY_MODULE = exports.ALL_CARD_MANIFESTS = void 0;
const AresCardManifest_1 = require("./ares/AresCardManifest");
const ColoniesCardManifest_1 = require("./colonies/ColoniesCardManifest");
const CommunityCardManifest_1 = require("./community/CommunityCardManifest");
const PreludeCardManifest_1 = require("./prelude/PreludeCardManifest");
const PromoCardManifest_1 = require("./promo/PromoCardManifest");
const StandardCardManifests_1 = require("./StandardCardManifests");
const TurmoilCardManifest_1 = require("./turmoil/TurmoilCardManifest");
const AutomaCardManifest_1 = require("./automa/AutomaCardManifest");
const PreludeTwoCardManifest_1 = require("./preludeTwo/PreludeTwoCardManifest");
const VenusCardManifest_1 = require("./venusNext/VenusCardManifest");
const MoonCardManifest_1 = require("./moon/MoonCardManifest");
const LeaderCardManifest_1 = require("./leaders/LeaderCardManifest");
exports.ALL_CARD_MANIFESTS = [
    StandardCardManifests_1.BASE_CARD_MANIFEST,
    StandardCardManifests_1.CORP_ERA_CARD_MANIFEST,
    PromoCardManifest_1.PROMO_CARD_MANIFEST,
    VenusCardManifest_1.VENUS_CARD_MANIFEST,
    ColoniesCardManifest_1.COLONIES_CARD_MANIFEST,
    PreludeCardManifest_1.PRELUDE_CARD_MANIFEST,
    PreludeTwoCardManifest_1.PRELUDE_TWO_CARD_MANIFEST,
    TurmoilCardManifest_1.TURMOIL_CARD_MANIFEST,
    CommunityCardManifest_1.COMMUNITY_CARD_MANIFEST,
    AresCardManifest_1.ARES_CARD_MANIFEST,
    MoonCardManifest_1.MOON_CARD_MANIFEST,
    LeaderCardManifest_1.LEADER_CARD_MANIFEST,
    AutomaCardManifest_1.AUTOMA_CARD_MANIFEST,
];
function allCardNames(decks) {
    const cardNames = [];
    for (const deck of decks) {
        deck.factories.forEach((cf) => {
            const misinformationDuplicates = [...CommunityCardManifest_1.MISINFORMATION_CARDS].slice(0, CommunityCardManifest_1.MISINFORMATION_CARDS.length - 1);
            if (misinformationDuplicates.includes(cf.cardName) === false)
                cardNames.push(cf.cardName);
        });
    }
    return cardNames;
}
exports.MANIFEST_BY_MODULE = new Map(exports.ALL_CARD_MANIFESTS.map((manifest) => [manifest.module, manifest]));
exports.ALL_PROJECT_DECKS = exports.ALL_CARD_MANIFESTS.map((deck) => deck.projectCards);
const ALL_CORPORATION_DECKS = exports.ALL_CARD_MANIFESTS.map((deck) => deck.corporationCards);
exports.ALL_PRELUDE_DECKS = exports.ALL_CARD_MANIFESTS.map((deck) => deck.preludeCards);
exports.ALL_STANDARD_PROJECT_DECKS = exports.ALL_CARD_MANIFESTS.map((deck) => deck.standardProjects);
exports.ALL_PROJECT_CARD_NAMES = allCardNames(exports.ALL_PROJECT_DECKS);
exports.ALL_STANDARD_PROJECT_CARD_NAMES = allCardNames(exports.ALL_STANDARD_PROJECT_DECKS);
exports.ALL_TURMOIL_ACTION_CARD_NAMES = allCardNames([TurmoilCardManifest_1.TURMOIL_CARD_MANIFEST.turmoilActions]);
exports.ALL_CORPORATION_CARD_NAMES = allCardNames(ALL_CORPORATION_DECKS);
exports.ALL_PRELUDE_CARD_NAMES = allCardNames(exports.ALL_PRELUDE_DECKS);
exports.ALL_LEADER_CARD_NAMES = allCardNames([LeaderCardManifest_1.LEADER_CARD_MANIFEST.leaderCards]);
//# sourceMappingURL=AllCards.js.map